import { render, staticRenderFns } from "./RelatedPerformances.vue?vue&type=template&id=0ca625b0&"
import script from "./RelatedPerformances.vue?vue&type=script&lang=ts&"
export * from "./RelatedPerformances.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockHorizontalList: require('/tmp/build_71ad00c4/src/components/block/HorizontalList.vue').default})
